export default "__VITE_ASSET__DsDggki6__"